import React, { useState } from 'react';

export default function ImageWithLoader({ src, alt, style, className }) {
  const [loaded, setLoaded] = useState(false);

  return (
    <div
      style={{
        position: 'relative',
        overflow: 'hidden',
        ...style,
      }}
      className={className}
    >
      {!loaded && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            height: '100%',
            width: '100%',
            backgroundColor: '#f8f9fa',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 2,
          }}
        >
          <div
            className="spinner-grow"
            role="status"
            style={{
              width: '2rem',
              height: '2rem',
              backgroundColor: '#184A2C',
            }}
          />
        </div>
      )}

      <img
        src={src}
        alt={alt}
        onLoad={() => setLoaded(true)}
        onError={() => setLoaded(true)} // fallback in case image fails
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          borderRadius: '0px',
          display: loaded ? 'block' : 'none',
        }}
      />
    </div>
  );
}
